<template>
  <div class="footer">
    <div class="footer__inner">{{ copyright }}</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("app", ["appVersion", "copyright"]),
  },
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  background: transparent;
  border-top: 1px solid var(--portal-border);
}

.footer__inner {
  padding: 0.85rem 1.25rem;
  color: var(--portal-text-muted);
  font-size: 0.8rem;
  font-weight: 500;
  text-align: center;
}
</style>
